import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
} from "docx";
import { Invoice } from "@/interface/entityInterface";
import { format } from "date-fns";
import { unparse as convertToCsv } from 'papaparse';
import { getNestedProperty } from "./functions";

export const generateInvoiceDoc = async (invoice: Invoice) => {
  if (!invoice) return null;
  const doc = new Document({
    sections: [
      {
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text: "Invoice",
                bold: true,
                size: 36,
              }),
            ],
            spacing: { after: 300 },
          }),

          new Paragraph(`Invoice ID: ${invoice.id}`),
          new Paragraph(
            `Date: ${invoice.date ? format(invoice.date, "dd MMMM yyyy HH:mm") : "-"}`,
          ),
          new Paragraph(`Payment Method: ${invoice.payment}`),
          new Paragraph(`Total: $${invoice.total}`),
          new Paragraph(`Paid: ${invoice.status === "Paid" ? "Yes" : "No"}`),
          new Paragraph(""),

          new Paragraph({
            children: [
              new TextRun({ text: "Client details", bold: true, size: 28 }),
            ],
            spacing: { after: 200 },
          }),

          new Paragraph(`Client: ${invoice.guest_user?.name}`),
          new Paragraph(`Email: ${invoice.guest_user?.email}`),
          new Paragraph(`Phone: ${invoice.guest_user?.phone}`),
          new Paragraph(""),

          new Paragraph({
            children: [
              new TextRun({ text: "Vehicle details", bold: true, size: 28 }),
            ],
            spacing: { after: 200 },
          }),

          new Paragraph(`Mileage: ${invoice.guest_vehicle?.license_plate}`),
          new Paragraph(`VIN: ${invoice.guest_vehicle?.vin}`),
          new Paragraph(`Make: ${invoice.guest_vehicle?.make}`),
          new Paragraph(`Model: ${invoice.guest_vehicle?.model}`),
          new Paragraph(`Year: ${invoice.guest_vehicle?.year}`),
          new Paragraph(""),

          new Paragraph({
            children: [new TextRun({ text: "Services", bold: true, size: 28 })],
            spacing: { after: 200 },
          }),

          new Table({
            width: { size: 100, type: WidthType.PERCENTAGE },
            rows: [
              new TableRow({
                children: [
                  new TableCell({ children: [new Paragraph("Service Name")] }),
                  new TableCell({ children: [new Paragraph("Description")] }),
                  new TableCell({ children: [new Paragraph("Price ($)")] }),
                  new TableCell({ children: [new Paragraph("Total ($)")] }),
                ],
              }),

              ...invoice.invoice_items.map(
                (item) =>
                  new TableRow({
                    children: [
                      new TableCell({ children: [new Paragraph(item.title)] }),
                      new TableCell({
                        children: [
                          new Paragraph(`${item.quantity} ${item.unit}`),
                        ],
                      }),
                      new TableCell({
                        children: [new Paragraph(`${item.price}`)],
                      }),
                      new TableCell({
                        children: [
                          new Paragraph(`${item.price * item.quantity}`),
                        ],
                      }),
                    ],
                  }),
              ),
            ],
          }),

          new Paragraph(""),
          new Paragraph(`${invoice.notes}`),
        ],
      },
    ],
  });

  const blob = await Packer.toBlob(doc);
  const url = URL.createObjectURL(blob)

  const a = document.createElement("a");
  a.href = url;
  a.download = `Invoice_${invoice.id}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

};

export const exportTable = (columns: {header: string, accessorKey: string}[], data: any[]) => {
  const validColumns = columns.filter(col => col.accessorKey);
  const tableCols = [...validColumns, 
    {header: "Commission percentage", accessorKey: "commission_partner.percentage_commission"},
    {header: "Commission value", accessorKey: "commission_value"}
  ]

  const result =  data.map(row => {
    const newObj: any = {};
    tableCols.forEach(col => {
      let headerValue = null;
      if (col.accessorKey.includes(".")) {
        if (col.accessorKey === "commission_partner.percentage_commission" && !getNestedProperty(row, col.accessorKey)) return;
        headerValue = getNestedProperty(row, col.accessorKey)
      }
      else if (col.accessorKey === 'fare') headerValue = `${row[col.accessorKey]} ${row.currency}`
      else if (col.accessorKey === 'commission_value') headerValue = row.commission_partner?.percentage_commission ? `${(row?.fare * (row.commission_partner?.percentage_commission / 100)).toFixed(2)} ${row?.currency}` : null
      else if (col.accessorKey) headerValue = row[col.accessorKey]
      newObj[col.header] = headerValue;
    });
    return newObj;
  });

  const csv = convertToCsv(result, { header: true });
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'orders.csv');
  document.body.appendChild(link);
  link.click();
}
